export default __webpack_public_path__ + "ecole.7fbd79f.png";